import React, {Fragment} from "react";
import Select from "../../../form/Select";
import {connectAdvanced} from "src/store";
import Button from "../../../form/Button";
import {CurrencyFormatter, optionsTemplate, ProductColumn} from "../../../../utils/formatters";
import {Tooltip} from "react-tippy";
import ComponentLoader from "../../../form/ComponentLoader";
import Modal from "../../../layout/Modal";
import ComponentConfig from "../../../form/ComponentConfig";
import Portal from "../../../layout/Portal";
import {get} from "../../../../utils/dotutils";
import TextInput from "../../../form/TextInput";
import SelectorGrid from "../../../form/SelectorGrid/SelectorGrid";
import CheckBox from "../../../form/CheckBox";
import QueryBuilder from "../NewsLetter/QueryBuilder/QueryBuilder";
import ProgressBar from "../../../form/ProgressBar";
import RadioGroup from "../../../form/RadioGroup";
import DiscountList from "../../lists/DiscountList";
import Tabs from "../../../layout/Tabs";
import TabContent from "../../../layout/TabContent";
import Tab from "../../../layout/Tab";
import Icon from "../../../form/Icon";
import {loadComponent} from "../../../../utils/components";
import ContentLoader from "../../../layout/ContentLoader";
import PropsProxy from "../../../layout/PropsProxy";
import XLSX from "xlsx";
import {operation} from "../../../../utils/other";

const sortable = true;
const filterable = true;

const makeid = (length) => {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() *
            charactersLength));
    }
    return result;
}

const customProductImporterFunc = async (args) => {

    const build = (data, _import) => {
        return new Promise(resolve => {
            let workbook = XLSX.read(data, {
                type: 'binary'
            });

            let defaultSheet = null;
            if (workbook?.Workbook?.WBView?.[0]?.activeTab) {
                defaultSheet = workbook.Workbook.WBView[0].activeTab;
            }

            let sheet = _import?.config?.sheet || defaultSheet || 0;

            function getArrayOfArrayByRange(sheet, rawRange = null) {
                rawRange = rawRange || sheet['!ref'];
                if (!rawRange) {
                    return [];
                }
                let arrOfArr = [];
                let range = XLSX.utils.decode_range(rawRange);
                for (let row = 0/*range.s.r*/; row <= range.e.r; row += 1) {
                    let rowArr = []
                    for (let col = 0/*range.s.c*/; col <= range.e.c; col += 1) {
                        let addr = XLSX.utils.encode_cell({ c: col, r: row});
                        let value = sheet[addr] && sheet[addr].v;    // sheet[addr] may be undefined
                        rowArr.push(value);
                    }
                    arrOfArr.push(rowArr);
                }
                return arrOfArr;
            }

            //workbook.SheetNames.forEach(function(sheet) {
            resolve({
                meta: {
                    sheets: workbook.SheetNames,
                    sheet
                },
                data: getArrayOfArrayByRange(workbook.Sheets[workbook.SheetNames[sheet]])
            });
            //})
        });
    }
    const parse = (file) => {
        return new Promise(resolve => {
            let reader = new FileReader();
            reader.onload = result => {
                resolve(result.target.result);
            };
            reader.readAsBinaryString(file);
        });
    }

    const filterRow = (filter, row) => {
        if (Array.isArray(filter)) {
            for (const subFilter of filter) {
                if (!filterRow(subFilter, row)) {
                    return false;
                }
            }
            return true;
        } else if (filter?.filters) {
            const operator = filter.operator || "AND";
            if (operator.trim().toUpperCase() === "OR") {
                for (const subFilter of filter.filters) {
                    if (filterRow(subFilter, row)) {
                        return true;
                    }
                }
                return false;
            } else if (operator.trim().toUpperCase() === "AND") {
                for (const subFilter of filter.filters) {
                    if (!filterRow(subFilter, row)) {
                        return false;
                    }
                }
                return true;
            }
        } else {
            if (filter.field) {
                const operator = (filter.operator || "=").toUpperCase();
                switch (operator) {
                    case "not isnull":
                        return get(row, filter.field) !== null && get(row, filter.field) !== undefined;
                    case "isnull":
                        return get(row, filter.field) === null || get(row, filter.field) === undefined;
                    case "!~":
                    case "~":
                    case "!=":
                    case "==":
                    case "<":
                    case ">":
                    case "<=":
                    case ">=":
                    case "===":
                    case "not in":
                    case "in":
                    case "includes":
                    case "not includes":
                        return operation(get(row, filter.field), filter.value, operator);
                    case "LIKE":
                        // https://stackoverflow.com/a/37511463
                        let fieldValue = String(get(row, filter.field));
                        fieldValue = fieldValue.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
                        let value = String(filter.value);
                        value = value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
                        const matchmode = filter.matchmode || "any";
                        switch (matchmode) {
                            case "start":
                                return String(fieldValue).indexOf(value) === 0;
                            case "end":
                                const s = String(fieldValue);
                                const suffix = String(value);
                                return s.indexOf(suffix, s - suffix.length) !== -1;
                            case "any":
                                return String(fieldValue).indexOf(value) !== -1;
                        }
                        return false;
                }
            }
            return true;
        }
    }


    const b = await build(await parse(args.file), args.config);
    let data = b.data.filter((row, idx) => {
        if (args.config.firstRowIsAHead > idx) return false;
        const obj = {};
        Object.keys(args.config.fields).map((key) => {
            obj[key] = row[args.config.fields[key].column];
        })
        return filterRow(args.config.filters, obj);
    }).map((row) => {
        return row[args.config.fields[args.config.component_data.product.filterfield].column];
    });
    let values = [];
    const chunkSize = 100;
    for (let i = 0; i < data.length; i += chunkSize) {
        const chunk = data.slice(i, i + chunkSize);
        const list = await loadComponent("componentlist", {
            component: "product",
            itemsperpage: chunkSize,
            filter: [
                {
                    field: args.config.component_data.product.filterfield,
                    value: chunk,
                    operator: "in"
                }
            ],
            view: [Object.keys(args.config.component_data.product.fields)[0]]
        });
        values = [...values, ...list.items.map((row) => {
            return row[Object.keys(args.config.component_data.product.fields)[0]]
        })];
    }
    values = values.filter((item, index) => values.indexOf(item) === index);

    args.onImport(values);
}

const customProductImporterId = (new Date()).getTime() + makeid(10);

const customImporters = (props) => {
    if (props.componentConfig.componentname === "product") {
        return [
            {
                id: customProductImporterId,
                label: "Termék lista",
                token: "Termék lista",
                config: {
                    "firstRowIsAHead": 0,
                    "fields": {
                        "barcode": {
                            "required": true,
                            "column": 0
                        }
                    },
                    "filters": [
                        {
                            "field": "barcode",
                            "value": "",
                            "operator": "!="
                        }
                    ],
                    "component_data": {
                        "product": {
                            "filterfield": "barcode",
                            "fields": {
                                [props.selectionField]: props.selectionField
                            }
                        }
                    }
                },
                callback: (args) => customProductImporterFunc({...args, onImport: props.onImport})
            }
        ];
    } else {
        return [];
    }
}

class ComponentSelect extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            opened: false,
            selection: (this.props.value || []),
            filtered: this.props.disabled || !!(this.props.value || []).length || false,
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (JSON.stringify(this.props.value || []) !== JSON.stringify(prevProps.value || [])) {
            this.setState({selection: (this.props.value || [])});
        }
        if (this.props.disabled !== prevProps.disabled) {
            this.setState({filtered: this.props.disabled || false});
        }
    }

    getNameField = () => {
        if (this.props.componentName === "product") {
            return "displayname";
        }
        let labelKey = null;
        const componentConfig = this.props.componentConfig;
        if (componentConfig.namefield) {
            labelKey = componentConfig.namefield;
        } else if ((componentConfig.fielddefs || {}).name) {
            labelKey = "name";
        } else if ((componentConfig.fielddefs || {}).title) {
            labelKey = "title";
        } else if ((componentConfig.fielddefs || {}).label) {
            labelKey = "label";
        }
        return labelKey || "name";
    }

    getColumnProps = () => {
        if (this.props.componentName === "product") {
            return ProductColumn(this.props.componentConfig.idfield);
        }
        return {};
    }

    getColumns = () => {
        return {
            [this.props.componentConfig.idfield]: {
                header: 'Kód',
                width: 1,
                sortable: true,
                filterable: true,
            },
            [this.getNameField()]: {
                header: 'Megnevezés',
                width: 11,
                sortable: true,
                filterable: true,
                ...this.getColumnProps()
            },
            ...(this.props.componentName === "product" ? {
                "barcode": {
                    header: 'Vonalkód',
                    sortable,
                    filterable
                },
                "sku": {
                    header: 'ISBN',
                    sortable,
                    filterable
                },
                "listprice": {
                    header: 'Lista ár',
                    width: 1,
                    className: 'nowrap',
                    sortable,
                    filterable,
                    renderer: CurrencyFormatter
                }
            }: {

            })
        };
    }

    render() {
        return (
            <Fragment>
                <Button
                    color="default"
                    icon={{lib: "fa", name: "search"}}
                    onClick={() => this.setState({opened: !this.state.opened})}
                >
                    ({(this.props.value || []).length} db)
                </Button>
                {this.state.opened && <Portal>
                    <Modal
                        state={this.state.opened}
                        header="Kiválasztás"
                        size="large"
                        buttons={[
                            {
                                text: "Mégse",
                                props: {color: "default"},
                                onClose: true,
                                onClick: async () => {
                                    try {
                                        this.setState({opened: false, selection: (this.props.value || [])});
                                    } catch (e) {

                                    }
                                }
                            },
                            {
                                text: "Kiválasztás",
                                props: {color: "primary", disabled: this.props.disabled || this.props.isLoading || (this.props.value || []).join(",") === this.state.selection.join(",")},
                                onClick: async () => {
                                    try {
                                        this.props.saveChanges && this.props.saveChanges(null, this.state.selection);
                                        this.setState({opened: false});
                                    } catch (e) {

                                    }
                                }
                            }
                        ]}
                    >
                        <SelectorGrid
                            component={this.props.componentName}
                            view={[this.props.componentConfig.idfield, this.props.field]}
                            columns={{
                                ...this.getColumns(),
                                actions: {
                                    header: ' ',
                                    width: 'cell-button',
                                    renderer: (value, rowData) => {
                                        const checked = !!this.state.selection.find((selection) => selection + "" === "" + rowData[this.props.field]);
                                        return <CheckBox
                                            value={1}
                                            checked={checked}
                                            label={false}
                                            saveChanges={() => {
                                                let selection = [...this.state.selection];
                                                selection = selection.filter((selection) => selection + "" !== "" + rowData[this.props.field]);
                                                if (!checked) {
                                                    selection.push(rowData[this.props.field]);
                                                }
                                                selection.sort();
                                                this.setState({selection});
                                            }}
                                            disabled={this.props.disabled || this.props.isLoading}
                                        />;
                                    }
                                }
                            }}
                            filter={this.state.filtered ? {field: this.props.field, value: this.state.selection.length ? this.state.selection : [-1], operator: "in"} : undefined}
                            paginatorRight={(props) => {
                                return <Tooltip title={!this.state.filtered ? "Csak a kiválasztottakat mutasd" : "Mindent mutat"}>
                                    <CheckBox
                                        onIcon={{lib: "fa", name: "box"}}
                                        offIcon={{lib: "fa", name: "box-open"}}
                                        value={1}
                                        checked={this.state.filtered}
                                        label={false}
                                        saveChanges={(field, value) => {
                                            this.setState({filtered: !!value});
                                        }}
                                        {...props}
                                        disabled={props.disabled || this.props.disabled || this.props.isLoading}
                                    />
                                </Tooltip>
                            }}
                            importers={{
                                customImporters: (props) => customImporters({
                                    ...props,
                                    selectionField: this.props.field,
                                    onImport: (selection) => {
                                        let newSelection = [...(this.props.value || []), ...selection];
                                        newSelection.filter((item, index) => newSelection.indexOf(item) === index);
                                        this.setState({selection: newSelection});
                                    }
                                })
                            }}
                            orderBy={{field: this.getNameField(), direction: "ASC"}}
                        />
                    </Modal>
                </Portal>}
            </Fragment>
        );
    }
}

const ValueEditorComp = (editorProps) => {
    const configs = editorProps.fieldData.configs;
    const xtradata = editorProps.fieldData.xtradata;
    const condition = editorProps.fieldData.condition;
    const component = get(xtradata, "component");
    const option = get(xtradata, "option");
    const componentConfig = get(configs, "config_" + condition.optionid);
    const field = get(xtradata, "field") || (componentConfig || {}).idfield;

    let comp = null;
    if (editorProps.field && component && (editorProps.operator === "in" || editorProps.operator === "not in")) {
        comp = <ComponentSelect
            disabled={editorProps.disabled}
            componentConfig={componentConfig}
            componentName={component}
            field={field}
            value={typeof editorProps.value === "string" ? editorProps.value.split(",").filter(Boolean) : editorProps.value}
            saveChanges={(_field, value) => {
                editorProps.handleOnChange(value);
            }}
        />;
    } else if (component) {
        let tooltip = {};
        let Template;
        if (editorProps.value && component && field === (componentConfig || {}).idfield && (Template = optionsTemplate(component))) {
            tooltip = {
                position: "top",
                style: {display: undefined},
                html: <ComponentLoader
                    view={Template.view}
                    componentName={component}
                    componentId={editorProps.value}
                    componentAs={(values) => values}
                >
                    <Template />
                </ComponentLoader>
            };
        }

        const isTippy = !!Object.keys(tooltip).length;

        const Tag = isTippy ? Tooltip : "div";
        comp = <div className="flex-grow-6">
            <Tag {...tooltip}>
                <Select
                    component={component}
                    objectValue={true}
                    valueKey={field}
                    storeType="remote"
                    view={[field]}
                    disabled={editorProps.disabled}
                    optionsTemplate={optionsTemplate(component)}
                    saveChanges={(_field, value) => {
                        editorProps.handleOnChange(value[field]);
                    }}
                    value={editorProps.value}
                    label={false}
                />
            </Tag>
        </div>;
    } else if (option) {
        comp = <div className="flex-grow-6">
            <Select
                optionname={option}
                objectValue={true}
                storeType="local"
                disabled={editorProps.disabled}
                saveChanges={(_field, value) => {
                    editorProps.handleOnChange(value.optionid);
                }}
                value={editorProps.value}
                label={false}
            />
        </div>;
    } else if (editorProps.field) {
        let formatter = null;
        if (editorProps.field.indexOf("price") !== -1) {
            formatter = CurrencyFormatter;
        }
        if (editorProps.operator.toLowerCase() === "between" || editorProps.operator.toLowerCase() === "not between") {
            comp = <Fragment>
                <div className="flex-grow-1">
                    <TextInput
                        placeholder="Tól"
                        disabled={editorProps.disabled}
                        formatter={formatter}
                        saveChanges={(_field, value) => {
                            const values = (editorProps.value || []);
                            values[0] = value;
                            editorProps.handleOnChange(values);
                        }}
                        value={(editorProps.value || [])[0] || ''}
                        label={false}
                    />
                </div>
                <div className="flex-grow-1">
                    <TextInput
                        placeholder="Ig"
                        disabled={editorProps.disabled}
                        formatter={formatter}
                        saveChanges={(_field, value) => {
                            const values = (editorProps.value || []);
                            values[0] = values[0] || 0;
                            values[1] = value;
                            editorProps.handleOnChange(values);
                        }}
                        value={(editorProps.value || [])[1] || ''}
                        label={false}
                    />
                </div>
            </Fragment>
        } else {
            comp = <div className="flex-grow-6">
                <TextInput
                    disabled={editorProps.disabled}
                    formatter={formatter}
                    saveChanges={(_field, value) => {
                        editorProps.handleOnChange(value);
                    }}
                    value={editorProps.value}
                    label={false}
                />
            </div>;
        }
    }

    return comp;
};

class ComplexFilterQueryBuilder extends React.Component {

    constructor(props) {
        super(props);

        const type = this.getType(props.value);

        this.state = {
            type,
            defaultType: type,
        }
    }

    getType = (filter) => {
        filter = filter || this.props.value;
        return !filter || (!filter.filters.some((filter) => !!filter.filters) && (filter.filters.filter((filter) => !filter.filters).length <= 1 || (filter.operator || "").toLowerCase() === "or")) ? "simple" : "complex";
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const type = this.getType();
        if (this.state.defaultType === "simple" && type === "complex") {
            this.setState({
                type,
                defaultType: type
            });
        }
    }

    saveChanges = (field, value) => {
        if (this.getType(this.props.value) === "simple" && this.getType(value || {}) === "complex" && (this.props.value?.operator || "").toLowerCase() === "and" && (value?.operator || "").toLowerCase() === "and") {
            value.operator = "OR";
        }
        this.props.saveChanges(field, value);
    }

    render() {
        const props = this.props;
        const currentFields = props.properties.items.map((condition) => {
            const xtradata = JSON.parse(condition.xtradata);
            const operators = (get(xtradata, "operators") || [{
                operator: '=',
                label: '='
            }]).map((filter) => ({name: filter.operator, label: filter.label}));

            return {
                name: condition.optionid,
                label: condition.optionlabel,
                operators,
                xtradata,
                condition,
                configs: props.configs,
                valueEditor: ValueEditorComp
            }
        });


        const type = this.getType();

        let radio = null;
        if (!this.props.disabled) {
            radio = <RadioGroup
                name={"radio_" + (new Date().getTime())}
                labelKey="label"
                valueKey="value"
                objectValue={false}
                disabled={type !== "simple"}
                options={[{value: "simple", label: "Egyszerű"}, {value: "complex", label: "Összetett"}]}
                value={this.state.type}
                label={false}
                saveChanges={(field, type) => {
                    this.setState({type});
                }}
            />;

            if (type === "complex") {
                radio = <Tooltip title="Összetett szűrőt nem lehet egyszerűvé alakítani!">
                    {radio}
                </Tooltip>
            }
        }

        return (
            <Fragment>
                <div className="col-md-12">
                    {radio}
                </div>
                <QueryBuilder
                    className={this.state.type}
                    fields={currentFields}
                    opened={true}
                    {...props}
                    saveChanges={(field, name) => {
                        this.saveChanges(field, name);
                    }}
                />
            </Fragment>
        );
    }
}

const ComplexFilterList = (props) => {
    let comp = <ComplexFilterQueryBuilder
        {...props}
    />;
    props.properties.items.map((condition, idx) => {
        const xtradata = JSON.parse(condition.xtradata);
        const component = get(xtradata, "component");
        if (component) {
            comp = <ComponentConfig
                componentName={component}
                componentConfigAs={"configs.config_" + condition.optionid}
                loader={() => <ProgressBar
                    min={0}
                    max={props.properties.items.length}
                    now={props.properties.items.length - idx}
                />}
            >
                {comp}
            </ComponentConfig>;
        }
    });
    return comp;
}

let properties = null;

class ComplexFilter extends React.Component {

    constructor(props) {
        super(props);
        this.state = {properties};
        if (properties === null) {
            this.loadDiscountConditionProperties();
        }
    }

    loadDiscountConditionProperties = () => {
        loadComponent("componentlist", {
            component: "option",
            optionname: "DiscountConditionProperty",
            view: ["optionid", "optionlabel", "xtradata"]
        }).then((data) => {
            properties = data;
            this.setState({properties})
        })
    }

    render() {
        if (this.state.properties === null) return <ContentLoader />;
        return <ComplexFilterList {...this.props} properties={this.state.properties} />;
    }
}

class SelectCondition extends React.Component {

    state = {
        opened: false,
        confirm: false,
        selection: null
    }

    saveChanges = (value) => {
        this.props.saveChanges(value);
    }

    render() {
        return (
            !this.props.disabled &&
            <Fragment>
                <Portal>
                    <Modal
                        state={this.state.opened}
                        size="large"
                        header={this.props.name === "targets" ? "Cél szürők importálása" : (this.props.name === "conditions" ? "Feltétel szűrők importálása" : "Kizárás szűrők importálása")}
                        buttons={[
                            {
                                text: 'Mégse',
                                props: {color: "default", disabled: this.props.disabled || this.props.isLoading},
                                onClose: true,
                                onClick: async () => {
                                    try {
                                        this.setState({opened: false});
                                    } catch (e) {

                                    }
                                }
                            },
                            {
                                text: 'Mehet',
                                props: {color: "primary", disabled: this.props.disabled || this.props.isLoading || !this.state.selection},
                                onClick: async () => {
                                    if ((this.props.conditions || []).length) {
                                        this.setState({confirm: true});
                                    } else {
                                        this.saveChanges([...this.state.selection[this.props.name]]);
                                        this.setState({confirm: false, opened: false, selection: null});
                                    }
                                }
                            }
                        ]}
                    >
                        <ComponentConfig componentName="discount">
                            <DiscountList view={[this.props.name]} selectionMode="single" selection={this.state.selection} loadForm={(selection) => {
                                this.setState({selection});
                            }} />
                        </ComponentConfig>
                        {!!this.state.selection &&
                            <Conditions
                                {...this.props}
                                type={this.props.type}
                                name={this.props.name}
                                conditions={this.state.selection[this.props.name]}
                                disabled={true}
                            />
                        }
                    </Modal>
                </Portal>
                <Portal>
                    <Modal
                        state={this.state.confirm}
                        size="medium"
                        buttons={[
                            {
                                text: 'Mégse',
                                props: {color: "default", disabled: this.props.disabled || this.props.isLoading},
                                onClose: true,
                                onClick: async () => {
                                    try {
                                        this.setState({confirm: false});
                                    } catch (e) {

                                    }
                                }
                            },
                            {
                                text: 'Felülírom',
                                props: {color: "danger", disabled: this.props.disabled || this.props.isLoading},
                                onClick: async () => {
                                    this.saveChanges([...this.state.selection[this.props.name]]);
                                    this.setState({confirm: false, opened: false, selection: null});
                                }
                            },
                        ]}
                    >
                        Úgy látom már nem üres a lista amihez importálni szeretnél, felülírod?
                    </Modal>
                </Portal>
                {this.props.children
                ?
                    <PropsProxy
                        onClick={(e) => {
                            e && e.preventDefault();
                            this.setState({opened: true});
                            return false;
                        }}
                    >
                        {this.props.children}
                    </PropsProxy>
                :
                    <Button
                        color="default"
                        onClick={(e) => {
                            e && e.preventDefault();
                            this.setState({opened: true});
                            return false;
                        }}
                    >
                        Importálás más kedvezményből
                    </Button>
                }
            </Fragment>
        );
    }
}

class Conditions extends React.Component {





    saveChanges = (value) => {
        if (this.props.saveChanges) {
            this.props.saveChanges(this.props.name, value);
        }
    }

    render () {
        const tabbed = this.props.name === "conditions" && this.props.values.calculation_strategy === "one_of_each";
        let conditions = this.props.conditions || [];

        if (!tabbed && conditions.length === 0) {
            conditions.push(null);
        }

        let tabs = conditions.map((condition, idx) => {
            const content = <div className="d-flex" key={idx}>
                <div className="d-flex flex-column flex-grow-1">
                    <ComplexFilter
                        disabled={this.props.disabled}
                        name="filter"
                        value={condition?.filter || {filters: [], operator: "OR"}}
                        saveChanges={(field, value) => {
                            if (!tabbed && !value.filters.length && value.operator.toLowerCase() === "or") {
                                value = null;
                            }
                            if (!tabbed && !value) {
                                this.saveChanges([]);
                            } else {
                                const newConditions = [...conditions];
                                newConditions[idx] = {...(condition || {}), filter: value};
                                this.saveChanges(newConditions);
                            }
                        }}
                    />
                </div>
            </div>;
            if (tabbed) {
                return (
                    <TabContent
                        key={idx}
                        tabLabel={<Fragment>
                            {idx+1}. Feltétel {!this.props.disabled && <Button
                                icon={{lib: "fa", name: "times"}}
                                size="xs"
                                color="danger"
                                onClick={(e) => {
                                    e && e.preventDefault();
                                    const newConditions = [...conditions];
                                    newConditions.splice(idx, 1);
                                    this.saveChanges(newConditions);
                                }}
                            />}
                        </Fragment>}
                        tabName={"condition_" + idx}
                    >
                        {content}
                    </TabContent>
                );
            }
            return (
                content
            );
        });

        let list;

        if (tabbed) {
            list = <Tabs
                defaultTab="condition_0"
                theme="default"
                extraTabs={
                    !this.props.disabled && <Fragment>
                        <SelectCondition {...this.props} saveChanges={this.saveChanges}>
                            <Tab
                                className="pull-right"
                            >
                                <Icon lib="fas" name="folder-plus" tooltip="Importálás más kedvezményből" />
                            </Tab>
                        </SelectCondition>
                        <Tab
                            className="pull-right"
                            onClick={() => this.saveChanges([...conditions, {}])}
                        >
                            <Icon lib="fas" name="plus" tooltip="Új feltétel hozzáadása" />
                        </Tab>
                    </Fragment>
                }
            >
                {tabs}
            </Tabs>
        } else {
            list = <Fragment>
                <div className="d-flex justify-content-end">
                    <SelectCondition {...this.props} saveChanges={this.saveChanges} />
                </div>
                {tabs}
            </Fragment>;
        }

        return (
            <div className="condition-holder">
                {list}
            </div>
        );
    }

}

export default connectAdvanced((dispatch) => {
        return (store, nextOwnProps) => {
            const newValues = store.editors[nextOwnProps.type].initialValues;
            return {
                newValues,
                ...nextOwnProps
            };
        }
    }
)(Conditions);